import axios from 'axios';
import { v2Api, API_ROOT } from './v2Client';
import { ensureAccessToken } from './authTokens';
import { clubRequestHeaders } from '../currentClub';

/** Configuration club / marque blanche — voir squash_manger_api_v2/docs/CLUB_CONFIGURATION.md. Administrateur (rôle 1). */

export async function fetchClubConfig() {
  const { data } = await v2Api.get('/ClubConfig');
  return data;
}

/** `values` : { clé: valeur } (seules les clés modifiées ; vide = défaut). `clearKeys` : secrets à effacer. */
export async function updateClubConfig(values, clearKeys = []) {
  const { data } = await v2Api.put('/ClubConfig', { values, clear_keys: clearKeys });
  return data;
}

/** Dépose l'image d'un réglage de type « image » (logo noir / blanc : PNG ou WebP) et l'enregistre aussitôt.
 * Retourne la configuration (vue admin), comme updateClubConfig. */
export async function uploadClubConfigImage(key, file) {
  const fd = new FormData();
  fd.append('key', key);
  fd.append('file', file);
  const access = await ensureAccessToken(API_ROOT);
  const headers = clubRequestHeaders();
  if (access) headers.Authorization = `Bearer ${access}`;
  const { data } = await axios.post(`${API_ROOT}/ClubConfig/upload_image`, fd, {
    headers,
    maxContentLength: 6 * 1024 * 1024,
    maxBodyLength: 6 * 1024 * 1024,
  });
  return data;
}

export async function fetchEmailTemplates() {
  const { data } = await v2Api.get('/ClubConfig/email_templates');
  return Array.isArray(data) ? data : [];
}

export async function saveEmailTemplate({ templateKey, subject, htmlBody }) {
  const { data } = await v2Api.put('/ClubConfig/email_template', {
    template_key: templateKey,
    subject,
    html_body: htmlBody,
  });
  return data;
}

export async function resetEmailTemplate(templateKey) {
  const { data } = await v2Api.post('/ClubConfig/email_template_reset', { template_key: templateKey });
  return data;
}

/** Aperçu avec valeurs d'exemple ; `subject` / `htmlBody` = brouillon non enregistré. */
export async function previewEmailTemplate({ templateKey, subject, htmlBody }) {
  const { data } = await v2Api.post('/ClubConfig/email_template_preview', {
    template_key: templateKey,
    subject,
    html_body: htmlBody,
  });
  return data;
}

/** `templateKey` absent = e-mail de test simple (vérifie le SMTP). */
export async function sendTestEmail({ to, templateKey }) {
  const { data } = await v2Api.post('/ClubConfig/send_test_email', { to, template_key: templateKey || null });
  return data;
}

/** Vérifie un code de l'ERP sans jamais le recevoir : `kind` = 'lock' (écran verrouillé) | 'advanced' (gestion
 * avancée). → true / false. */
export async function verifyErpPin(kind, pin) {
  const { data } = await v2Api.post('/ClubConfig/verify_pin', { kind, pin });
  return Boolean(data?.ok);
}

export function clubConfigErrorMessage(err, fallback) {
  return err?.response?.data?.message || err?.message || fallback;
}
